import { render, staticRenderFns } from "./BottomNavbar.vue?vue&type=template&id=1bf2fbd8&"
import script from "./BottomNavbar.vue?vue&type=script&lang=js&"
export * from "./BottomNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports